import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import CheckDrafts from '@project/common/check-drafts';

import Const       from 'fw_const';
import Utils       from 'utils';
// -------------------------------------------------------

class SummaryCheckDraft extends React.Component {
  render() {
    let data = this.props.data;
    let workflow = data.workflow;
    
    return (
      <div className="summary-check-draft">
        { (data.all_draft_count > 0) &&
          <div className="all-button" onClick={data.event.showDraftListModal.bind(this, data.project.id)}>すべて表示 ({data.all_draft_count})</div>
        }
        
        <CheckDrafts base={data} />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default SummaryCheckDraft;